import { ApiView, ApiViewState, getDefaultApiViewState } from '../../core/ApiView';
import {
  FetchFinancialConfigResult,
  financialConfigQuery,
  FinancialConfigResource
} from '../../queries/financialConfig';

export interface FinancialConfigViewState extends ApiViewState {
  financialConfig?: FetchFinancialConfigResult;
  isFetching: boolean;
}

export class FinancialConfigView extends ApiView {
  private financialConfigObs?: ReturnType<typeof financialConfigQuery>;

  public state: FinancialConfigViewState = {
    ...getDefaultApiViewState(),
    financialConfig: undefined,
    isFetching: false
  };

  constructor(resource: FinancialConfigResource | null) {
    super();
    if (resource) {
      this.financialConfigObs = this.addQuery(financialConfigQuery(resource));
    }
    this.updateState();
  }

  // * Public API *
  public async reload(): Promise<FetchFinancialConfigResult> {
    if (!this.financialConfigObs) {
      throw new Error('Cannot reload financial config without a resource');
    }
    const result = await this.financialConfigObs.refetch({ cancelRefetch: false, throwOnError: true });
    if (!result.data) {
      throw new Error('Financial config reload returned no data');
    }
    return result.data;
  }

  // * Private / Protected API *
  protected getNewState(): FinancialConfigViewState {
    const result = this.financialConfigObs?.getCurrentResult();
    return {
      ...super.getNewState(),
      financialConfig: result?.data,
      isFetching: result?.isFetching ?? false,
      isLoading: result?.isPending ?? false
    };
  }
}
